import React from 'react'
import { designTokens } from '@/utils/design-tokens'
import { DateInputProps } from './types'
import { formatDateRange } from './utils'

const DateInput: React.FC<DateInputProps> = ({
  startDate,
  endDate,
  onDateClick,
  timePeriod,
  className = '',
  readOnly = false
}) => {
  const dateRangeText = formatDateRange(startDate, endDate, timePeriod)

  const handleClick = () => {
    if (readOnly || !onDateClick) return

    // For period mode, clicking opens start date selection
    onDateClick('start')
  }

  return (
    <div
      className={`transition-all duration-150 rounded px-2 py-1 ${
        readOnly ? '' : 'cursor-pointer hover:bg-gray-50'
      } ${className}`}
      onClick={handleClick}
      style={{
        fontFamily: designTokens.typography.fontFamily.sans[0],
        fontSize: designTokens.typography.fontSize['body-small'][0],
        fontWeight: 600,
        color: designTokens.colors.gray[5],
        userSelect: 'none'
      }}
    >
      {dateRangeText || '날짜 선택'}
    </div>
  )
}

export default DateInput